import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { Subscription } from "rxjs";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { ScanHistoryViewDetailsComponent } from "./scan-history-view-details/scan-history-view-details.component";
import { DataService_ScanHistory } from "./shared/data.service";
export { StaffService } from "../services/staff.service";
import * as moment from "moment";

@Component({
	selector: "caass-staff-scan-history",
	templateUrl: "./scanhistory.component.html",
	styleUrls: ["./scanhistory.component.css"],
})
export class ScanHistoryComponent {
	constructor(
		private userService: UserService,
		private ScanHistoryService: DataService_ScanHistory,
		private dialogService: DialogService,
		private schoolService: SchoolService,
		private selectService: PersonSelectorService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onPersonSelectChange().subscribe((person) => {
			this.selectedStaff = person;
			this.loadScan();
		});
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	//Person Selector
	subscription: Subscription;
	selectedStaff: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedScan: any;
	lstScan: any = [];

	//Filter lists
	lstStationModeDesc: any = [];
	lstResultDesc: any = [];
	lstScanStation: any = [];
	lstManualDesc: any = [];
	lstFacilityName: any = [];
	lstFacilityLocationName: any = [];
	lstHasReminderDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "PersonName", header: "Name" },
		{ field: "ScanDTDesc", header: "Date" },
		{ field: "StationModeDesc", header: "Station Mode" },
		{ field: "ResultDesc", header: "Scan Result" },
		{ field: "ScanStation", header: "ScanStation" },
		{ field: "ManualDesc", header: "Manual" },
		{ field: "FacilityName", header: "Facility" },
		{ field: "FacilityLocationName", header: "Location" },
		{ field: "HasReminderDesc", header: "Has Reminder" },
	];

	///////////////

	StartDate: any = new Date();
	EndDate: any = new Date();

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadScan() {
		this.loading = true;

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.loading = false;
			return;
		}

		var result = this.ScanHistoryService.LoadScan(this.selectedStaff.SchoolID, this.selectedStaff.PersonID, fsDate, feDate, 1);
		result.subscribe(
			(response) => {
				this.lstScan = response;

				for (var i = 0; i < this.lstScan.length; i++) {
					var next = this.lstScan[i];

					next.ScanDTDesc = moment(new Date(next.ScanDT)).format("MM/DD/YYYY h:mm:ss a");
				}

				//Load Data Filter Lists
				this.lstStationModeDesc = Array.from(new Set(this.lstScan.map((item: any) => item.StationModeDesc))).sort();
				this.lstResultDesc = Array.from(new Set(this.lstScan.map((item: any) => item.ResultDesc))).sort();
				this.lstScanStation = Array.from(new Set(this.lstScan.map((item: any) => item.ScanStation))).sort();
				this.lstManualDesc = Array.from(new Set(this.lstScan.map((item: any) => item.ManualDesc))).sort();
				this.lstFacilityName = Array.from(new Set(this.lstScan.map((item: any) => item.FacilityName))).sort();
				this.lstFacilityLocationName = Array.from(new Set(this.lstScan.map((item: any) => item.FacilityLocationName))).sort();
				this.lstHasReminderDesc = Array.from(new Set(this.lstScan.map((item: any) => item.HasReminderDesc))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadScan();
	}

	//Custom Button Methods
	onViewDetails() {
		this.errorMessage = "";

		if (this.SelectedScan == undefined) {
			this.errorMessage = "Select a scan to view details";
			return;
		}

		var ref = this.dialogService.open(ScanHistoryViewDetailsComponent, {
			header: "View Details",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				ScanID: this.SelectedScan.ScanID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadScan();
			}
		});
	}

	onPrint() {
		this.errorMessage = "";

		//Error handling

		//Call SP

		//Create Report? (Doesn't work in 9.5?)
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedScan = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedScan = null;
	}
	onRowDblClick(Scan) {
		this.errorMessage = "";

		this.SelectedScan = Scan;
		this.onViewDetails();
	}

	onStartDateChange(val) {
		this.errorMessage = "";

		this.StartDate = val;

		this.loadScan();
	}

	onEndDateChange(val) {
		this.errorMessage = "";

		this.EndDate = val;

		this.loadScan();
	}
	////////////////////////////////////////////
}
